import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { AlertService } from '../../../services/alert.service';
import { UserAreaService } from '../../../services/user-area.service';

@Component({
  selector: 'app-redeem-member-area',
  templateUrl: './redeem-member-area.component.html',
  styleUrl: './redeem-member-area.component.scss',
  standalone: false,
})
export class RedeemMemberAreaComponent {
  public form: FormGroup = new FormGroup({
    code: new FormControl(null, Validators.required),
  });

  public isLoading = false;

  constructor(
    private userAreaService: UserAreaService,
    private alertService: AlertService,
    private dialogRef: DynamicDialogRef
  ) {}

  onRedeemCode(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.userAreaService
      .redeemCode(this.form.get('code')?.value.trim())
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.alertService.showSuccessAlert(
            res.message || 'Bereich freigeschaltet.'
          );
          this.dialogRef.close(true);
          this.form.reset();
        },
        error: err => {
          this.isLoading = false;
          this.alertService.showErrorAlert(
            err?.message || 'Code konnte nicht eingelöst werden.'
          );
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close(false);
    this.form.reset();
  }
}
